import dchAPI from '@/services/dchAPI';

// Not under /admin: the API's WAF blocks every request to a path with an admin segment.
export const SCHEDULES_OVERVIEW_PATH = 'monitoring/schedules';

const state = {
  overview: null,
  loading: false,
};

const getters = {
  schedulesOverview: (state) => state.overview,
  schedulesLoading: (state) => state.loading,
};

// Paging fires overlapping requests; only the latest one may touch the state or report an error.
let latestRequest = 0;

const actions = {
  async fetchSchedulesOverview({ commit }, { from, to }) {
    const request = ++latestRequest;
    commit('setSchedulesLoading', true);
    try {
      const response = await dchAPI.get(SCHEDULES_OVERVIEW_PATH, { params: { from, to } });
      if (request !== latestRequest) return undefined;
      commit('setSchedulesOverview', response.data.data);
      return response.data.data;
    } catch (error) {
      if (request !== latestRequest) return undefined;
      throw error;
    } finally {
      if (request === latestRequest) commit('setSchedulesLoading', false);
    }
  },
};

const mutations = {
  setSchedulesOverview(state, overview) {
    state.overview = overview;
  },
  setSchedulesLoading(state, loading) {
    state.loading = loading;
  },
};

export default { state, getters, actions, mutations };
